var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-context',{ref:"contextMenu",attrs:{"close-on-click":false},on:{"close":_vm.reset}},[(_vm.model)?_c('div',{class:_vm.$spa.css.contextmenu.container},[_vm._t("default",null,{"model":_vm.model,"data":_vm.data})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }